import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Logger.js";
import i from "./Field.js";
import t from "./FieldsIndex.js";
import { fixFields as r } from "./fieldUtils.js";
var s = e.getLogger("esri.layers.support.fieldProperties");

function l() {
  return {
    fields: {
      type: [i],
      value: null
    },
    fieldsIndex: {
      readOnly: !0,
      get: function get() {
        return new t(this.fields || []);
      }
    },
    outFields: {
      type: [String],
      json: {
        read: !1
      },
      set: function set(e) {
        this._userOutFields = e, this.notifyChange("outFields");
      },
      get: function get() {
        var e = this._userOutFields;
        if (!e || !e.length) return null;
        if (e.includes("*")) return ["*"];
        if (!this.fields) return e;

        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _i = _step.value;
            this.fieldsIndex.has(_i) || s.error("field-attributes-layer:invalid-field", "Invalid field ".concat(_i, " found in outFields"), {
              layer: this,
              outFields: e
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return r(this.fieldsIndex, e);
      }
    }
  };
}

export { l as defineFieldProperties };